import { render, staticRenderFns } from "./KamblyFooter.vue?vue&type=template&id=4af8e017&"
import script from "./KamblyFooter.vue?vue&type=script&lang=js&"
export * from "./KamblyFooter.vue?vue&type=script&lang=js&"
import style0 from "./KamblyFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports